import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import OtherCaseStudy from "../../components/other-case"
import forecr1 from "../../assets/img/forecr1.png"
import forecrelipse from "../../assets/img/forecrelipse.png"
import forecrb2beticaret from "../../assets/img/forecrb2beticaret.png"
import forecrorganikoturum from "../../assets/img/forecrorganikoturum.png"
import forecraynibutcepaidkanal from "../../assets/img/forecraynibutcepaidkanal.png"
import simay from "../../assets/img/teams/08.jpg"
import duhan from "../../assets/img/teams/duhan-pinduk.webp"
import yagmur from "../../assets/img/teams/yagmur-pinduk.webp"

const ReferancesDetail = () => (
  <Layout>
    <SEO
      title="FORECR Success Story | Flatart"
      description="FORECR success story — 257% organic traffic growth in B2B e-commerce through SEO and digital advertising campaigns."
    />
    <div className="referances-detail py60 container">
      <div className="col-md-6 detail-left">
        <b>SUCCESS STORY</b>
        <h1>FORECR</h1>
        <p><strong>FORECR</strong>, a brand that has established a strong position in the industry with industrial computing solutions, aims to introduce businesses to the latest technologies and facilitate innovation and efficiency. The brand, which bridges cutting-edge technology with industrial operations, accelerates the digital transformation journey of businesses by providing reliable and high-performance solutions across diverse sectors including healthcare, defense-aerospace, mining, industrial automation, smart city, smart agriculture, robotics, and autonomous-unmanned systems.</p>
        <h2>Key Challenges</h2>
        <ul>
          <li>• Low search volumes in narrow segments such as defense, rail systems, and industrial automation, with a niche target audience</li>
          <li>• Multi-location competition making it time-consuming to benchmark different competition levels across multiple countries.</li>
          <li>• Low brand awareness both domestically and internationally in highly competitive areas.</li>
          <li>• Longer and multi-stage purchasing journeys due to the complex nature of technical products,</li>
          <li>• Digital advertising campaigns and SEO infrastructure needed to be built from scratch.</li>
          <li>• Lack of website content, category hierarchy, and pages capable of attracting users to the brand.</li>
        </ul>
      </div>
      <div className="col-md-6 referances-boxs">
        <div className="boxs">
          <div className="box">
            <span>+%257</span>
            <p>Organic Traffic<br />Increase</p>
          </div>
          <div className="box">
            <span>-%82</span>
            <p>Cost Per<br />Click</p>
          </div>
          <div className="box">
            <span>8x</span>
            <p>Paid Channel<br />Revenue Growth</p>
          </div>
          <div className="box">
            <span>+%22</span>
            <p>New User<br />Count Increase</p>
          </div>
        </div>
        <div className="provided">
          <h3>Services Provided</h3>
          <div className="provided-box">
            <div className="box">
              <Link to="/search-engine-optimization/"></Link>
              <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                  <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                  <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                  <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                </g>
              </svg>
              SEO
            </div>
            <div className="box">
              <Link to="/digital-ads/"></Link>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 76 76">
                <g id="Icons-_-Shopping-_-Cart_1" data-name="Icons-/-Shopping-/-Cart#1" transform="translate(0.452 0.373)">
                  <rect id="bound" width="76" height="76" transform="translate(-0.452 -0.373)" fill="none" />
                  <path id="Combined-Shape" d="M52.453,31.233l-2.2,13.227-.008.046a3.161,3.161,0,0,1-3.675,2.544L10.63,40.517a3.161,3.161,0,0,1-2.474-2.241L2.389,18.088a3.161,3.161,0,0,1,3.039-4.029H48.813l1.938-8.306a3.729,3.729,0,0,1,3.632-2.882h6.527a3.729,3.729,0,1,1,0,7.459H57.342Z" transform="translate(4.899 6.203)" fillRule="evenodd" opacity="0.3" />
                  <path id="Combined-Shape-2" data-name="Combined-Shape" d="M9.741,27.482a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,9.741,27.482Zm28.447,0a4.741,4.741,0,1,1,4.741-4.741A4.741,4.741,0,0,1,38.188,27.482Z" transform="translate(10.804 38.894)" fillRule="evenodd" />
                </g>
              </svg>
              Digital Ads
            </div>
          </div>
        </div>
        <div className="project-details">
          <h3>Impressum</h3>
          <div className="project-details_list">
            <ul>
              <li>Brand Strategist:</li>
              <li>Digital Ads:</li>
              <li>SEO:</li>
            </ul>
            <ul>
              <li><img src={simay} alt="Simay Akkurt Çetin" />Simay Akkurt Çetin</li>
              <li><img src={duhan} alt="Duhan Vatansever" />Duhan Vatansever</li>
              <li><img src={yagmur} alt="Yağmur Çiftçi" />Yağmur Çiftçi</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="content-section content row reverse-mobile" style={{ display: "flex", flexWrap: "wrap" }}>
        <div className="col-md-6" style={{ paddingLeft: 0 }}>
          <h2 style={{ fontSize: 28, textAlign: "left", fontWeight: "bold", marginBottom: 20 }}>Solutions We Developed</h2>
          <p style={{ maxWidth: 500, textAlign: "left" }}>
            As Flatart Agency, we provided a realistic and multi-stage digital marketing solution throughout our work with FORECR. With our SEO and digital marketing team:
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • We conducted <strong>topical keyword research</strong> specific to each sector — defense, aerospace, rail systems, industrial automation, and more,
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Digital advertising campaigns were structured by country and segment. We redesigned bid strategies and budget allocations according to each country&apos;s competition level, cost per click, and conversion performance.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Through our segment- and country-based setups, we achieved significantly higher sales with the same budget,
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • We cleaned up irrelevant traffic through sector-specific negative keyword usage and intent-focused targeting.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left" }}>
            We integrated high-intent B2B marketing keywords — applied through our SEO team&apos;s optimizations — into search campaigns. We also grouped keywords that needed to be distinguished between the brand&apos;s general and sector-specific segments.
          </p>
        </div>
        <div className="col-md-6" style={{ position: "relative", minHeight: 400 }}>
          <img
            src={forecrelipse}
            alt=""
            className="d-none d-md-block"
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: "80%",
              zIndex: 1
            }}
          />
          <img
            src={forecr1}
            alt="FORECR Solutions We Developed"
            style={{
              position: "relative",
              width: "100%",
              zIndex: 2
            }}
          />
        </div>
      </div>

      <div className="text-center" style={{ marginTop: 60 }}>
        <h2>257% Organic Traffic Growth Through<br />SEO in B2B E-Commerce</h2>
        <img style={{ width: "100%", margin: "0 auto 30px" }} src={forecrb2beticaret} alt="B2B E-Commerce SEO Work" />
        <p style={{ fontSize: 18, margin: "0 auto 30px", maxWidth: 900 }}>
          We ran dedicated SEO campaigns to increase FORECR&apos;s digital visibility and boost its organic traffic. As a result of the work we applied:
        </p>
      </div>

      <div className="text-center" style={{ marginTop: 60 }}>
        <h2>Total revenue and conversion<br />performance increased by <b>+257%</b></h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          By targeting keyword groups with high purchase intent and creating pages aligned with user intent, a 257% increase in organic traffic-driven conversion performance was achieved.
        </p>
      </div>

      <div className="text-center" style={{ marginTop: 40 }}>
        <h2>Average keyword rankings<br /><b>improved by 32%</b></h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          As a result of SEO-compliant pages developed with a product and category focus, the average ranking for sector keywords improved by 32%.
        </p>
      </div>

      <div className="text-center" style={{ marginTop: 40 }}>
        <h2>Organic session count<br /><b>increased by 23%</b></h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          Following technical SEO improvements and user experience enhancements across the site, the number of sessions from organic traffic increased by 23%.
        </p>
        <img style={{ width: "70%", margin: "0 auto" }} src={forecrorganikoturum} alt="Organic Session Count Increase" />
      </div>

      <div className="text-center" style={{ marginTop: 60 }}>
        <h2>8X Growth in Paid Channel<br />Revenue with the Same Budget</h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          Through the combination of all our Ads optimizations, we delivered approximately 8X growth in paid channel revenue without increasing the budget. With the renewed campaign structure, we raised the quality score of the target audience and enabled ads to optimize based on genuine purchase signals. Ad copy and creative A/B tests were run for Google and LinkedIn, highlighting the best-performing combinations.
        </p>
        <img style={{ width: "100%", margin: "0 auto" }} src={forecraynibutcepaidkanal} alt="8X Paid Channel Revenue Growth with the Same Budget" />
      </div>

      <div className="text-center" style={{ marginTop: 60, marginBottom: 60 }}>
        <p style={{ fontSize: 18, lineHeight: 1.7, maxWidth: 900, margin: "0 auto" }}>
          We are pleased to witness the digital growth of FORECR, with whom we have collaborated across everything from SEO to digital advertising.
        </p>
        <p style={{ fontSize: 18, lineHeight: 1.7, maxWidth: 900, margin: "20px auto 0" }}>
          Together with FORECR, we aim for the same success for all our brands and continue to produce lasting results with the right digital marketing strategies.
        </p>
      </div>
    </div>

    <OtherCaseStudy />
    <Checkup />
  </Layout>
)

export default ReferancesDetail
